<template #Popularity>
    <div id="popularity">
        <div class="content">
            <div class="chart-container">
                <div class="header">
                    <FilterTool v-model="filters" :isGraphShowing="true" :keep-state-on-query-params="true" />
                </div>
                <div
                    v-if="loading"
                    class="h-50 d-flex flex-column justify-content-center align-items-center text-align-center"
                >
                    <a-spin />
                    <p>{{ $t("message.loading") }}</p>
                </div>
                <div class="charts-wrapper" v-else>
                    <div class="sub-header">
                        <div
                            class="left"
                            v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                            :content="'This report shows the popularity of all interactions in a given your chatbot story'"
                        >
                            <md-icon>help</md-icon>
                            <div class="title">{{ $t("message.interactionPopularity") }}</div>
                        </div>
                        <div class="right">
                            <div class="export-button" @click="exportToCsv">
                                <md-icon>system_update_alt</md-icon>
                                <span>{{ $t("chatbotv2.exportToCsv") }}</span>
                            </div>
                            <div class="export-button" @click="exportToExcel">
                                <md-icon>system_update_alt</md-icon>
                                <span>{{ $t("chatbotv2.exportToExcel") }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="dataSource && dataSource.length" class="charts-container">
                        <a-table
                            :columns="columns"
                            :dataSource="dataSource"
                            :pagination="false"
                            :rowClassName="getRowClassName"
                            rowKey="_id"
                            size="small"
                            class="blocks"
                            @change="tableChange"
                        >
                            <template slot="name" slot-scope="text, record">
                                <a
                                    class="blockName"
                                    :href="getBlockURL(record.id)"
                                    @click="(e) => gotoBlock(e, record.id)"
                                >
                                    <div v-if="record.name">
                                        {{ record.name }}
                                    </div>
                                    <div v-else>
                                        {{ $t(`chatbotv2.${record.type}`) }}
                                    </div>
                                </a>
                            </template>
                        </a-table>
                    </div>
                </div>
                <div class="d-flex justify-content-center mt-5" v-if="!loading && dataSource && !dataSource.length">
                    <ChartNotFound :title="$t('message.dataNotFound')" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SideMenuBar from "../../SideMenuBar";
import FilterTool from "../archive/FilterTool";
import ChartNotFound from "../../components/ChartNotFound";

import { IS_CHARTS_PUBLIC } from "../../chatbot";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import moment from "moment/moment";
import log2 from "../../../../../utils/log2";
import { CHATBOT_API } from "../../../../../api/chatbotv2";
import SYSTEM_PUBSUB from "../../../../../utils/systemPubSub";
import { expertToExcel, exportToCSV, tableSorter } from "../../../../../utils/utils";
import * as _ from "lodash";
import { PERMISSION_TYPES } from "../../../../../language/permissionTypes";
import ChatbotMenu from "../../ChatbotMenu.vue";

const log = log2("Popularity");
export default {
    name: "Popularity",
    components: { ChatbotMenu, ChartNotFound, FilterTool, SideMenuBar },
    data() {
        return {
            IS_CHARTS_PUBLIC,
            currentSort: {
                columnKey: "totalVisit",
                order: "descend",
            },
            columns: [
                {
                    title: this.$t("chatbotv2.interactionName"),
                    dataIndex: "name",
                    key: "name",
                    scopedSlots: { customRender: "name" },
                    ...tableSorter("name", "string", this.currentSort),
                },
                {
                    title: this.$t("message.interactionCount"),
                    dataIndex: "totalVisit",
                    key: "totalVisit",
                    ...tableSorter("totalVisit", "number", this.currentSort),
                },
                {
                    title: this.$t("message.uniqueUserCount"),
                    dataIndex: "totalUniqueUser",
                    key: "totalUniqueUser",
                    ...tableSorter("totalUniqueUser", "number", this.currentSort),
                },
                {
                    title: this.$t("message.allUserPercentage"),
                    dataIndex: "percentOfAllVisit",
                    key: "percentOfAllVisit",
                    ...tableSorter("percentOfAllVisit", "number", this.currentSort),
                },
            ],
            dataSource: [],
            loading: true,
            filters: {
                period: this.$route.query.period || "today",
                integration: this.$route.query.integration || null,
                storyId: this.$route.query.storyId || null,
                startDate: this.$route.query.startDate || moment().startOf("day").toISOString(),
                endDate: this.$route.query.endDate || moment().endOf("day").toISOString(),
            },
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
    },
    methods: {
        ...mapActions({
            listStories: "CB/listStories",
        }),
        tableChange(pagination, filters, sorter) {
            const newSort = {
                columnKey: sorter.columnKey,
                order: sorter.order,
            };
            const oldSort = this.currentSort;
            if (!_.isEqual(newSort, oldSort)) {
                this.currentSort = newSort;
                this.renderCount += 1;
                this.$forceUpdate();
            }
        },
        getRowClassName(record, index) {
            let className = "";
            return className;
        },
        fetchData() {
            this.loading = true;
            if (this.filters.period !== "custom") {
                this.filters.startDate = null;
                this.filters.endDate = null;
                this.$router.replace({
                    query: {
                        period: this.filters.period,
                        integration: this.filters.integration,
                        storyId: this.filters.storyId,
                    },
                });
            }
            CHATBOT_API.REPORT.blockPopularity({ ...this.filters })
                .then(async (res) => {
                    this.dataSource = res.data.result;
                    this.renderKey += 1;
                    log("blockPopularity fetch result", res.data);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getBlockURL(blockId) {
            const story = this.stories.find((x) => x.id === this.filters.storyId);
            const versions = _.get(story, "meta.versions", []).filter((x) => x.published);
            const version = _.get(_.orderBy(versions, ["publishDate"], ["desc"]), "0.version");

            return `/chatbot/story/${this.filters.storyId}/${version}/block/${blockId}?autoFocus=true`;
        },
        gotoBlock(e, blockId) {
            e.stopPropagation();
            e.preventDefault();
            this.$router.push(this.getBlockURL(blockId));
            setTimeout(() => {
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.CB_FOCUS_BLOCK, {
                    blockId,
                });
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.CB_SELECT_BLOCK, {
                    blockId,
                });
            }, 2000);
        },
        exportToCsv() {
            const story = this.stories.find((x) => x.id === this.filters.storyId);
            const csv = this.dataSource.map((x) => {
                return {
                    "Interaction Name": x.name || this.$t(`chatbotv2.${x.type}`),
                    "Number of Interaction": x.totalVisit,
                    "Number of Unique User": x.totalUniqueUser,
                    "Percent of All User": x.percentOfAllVisit,
                };
            });
            exportToCSV(csv, `chatbot_popularity_of_${story.title}.csv`);
        },
        exportToExcel() {
            const story = this.stories.find((x) => x.id === this.filters.storyId);
            const data = this.dataSource.map((x) => {
                return {
                    "Interaction Name": x.name || this.$t(`chatbotv2.${x.type}`),
                    "Number of Interaction": x.totalVisit,
                    "Number of Unique User": x.totalUniqueUser,
                    "Percent of All User": x.percentOfAllVisit,
                };
            });
            expertToExcel(data, `chatbot_popularity_of_${story.title}.xlsx`, "Chatbot Popularity");
        },
    },
    mounted() {
        this.listStories().then((stories) => {
            log("listStories", stories);
            if (this.filters.storyId) return;
            const integratedStoryCandidate = stories.find((story) => Object.values(story.integrations).includes(true));
            if (integratedStoryCandidate) {
                this.filters.storyId = integratedStoryCandidate.id;
            } else if (stories.length) {
                this.filters.storyId = stories[0].id;
            }
        });
        this.fetchData();
    },
    beforeMount() {
        if (this.checkPermission(PERMISSION_TYPES["chatbot.reports.view"].tr.name) === false) {
            return router.push("/denied");
        }
    },
    watch: {
        filters: {
            handler(newVal) {
                if (newVal !== undefined) {
                    log("filters changed", this.filters);
                    const date = new Date();

                    if (!newVal.period) {
                        newVal.period = "today";
                    }

                    if (newVal.period === "today" || newVal.period === "yesterday") {
                        this.timeSeriesType = "hourly";
                        if (newVal.period === "today") this.datePeriod = moment().hour() + 1;
                        if (newVal.period === "yesterday") this.datePeriod = 24;
                    } else if (
                        newVal.period === "last-3-month" ||
                        newVal.period === "this-year" ||
                        newVal.period === "last-year"
                    ) {
                        this.timeSeriesType = "monthly";
                        if (newVal.period === "last-3-month") this.datePeriod = 3;
                        if (newVal.period === "this-year") this.datePeriod = date.getMonth() + 1;
                        if (newVal.period === "last-year") this.datePeriod = 12;
                    } else {
                        this.timeSeriesType = "daily";
                        if (newVal.period === "last7") this.datePeriod = 7;
                        else if (newVal.period === "last30") this.datePeriod = 30;
                        else if (newVal.period === "this-month") this.datePeriod = date.getDate();
                        else if (newVal.period === "last-month")
                            this.datePeriod = new Date(date.getFullYear(), date.getMonth(), 0).getDate();
                    }
                    this.fetchData();
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss">
#popularity {
    width: 100%;
    height: auto;
    min-height: 100vh;
    display: flex;

    .side-menubar-wrapper {
        min-height: 100vh;
        flex: 0 0 15%;
        height: 100%;
    }

    .content {
        padding: 10px;
        display: flex;
        flex-direction: column;
        position: relative;
        background: white;
        width: 100%;
        height: 100%;
        min-height: 100vh;

        .chart-container {
            width: 100%;

            .header {
                width: 100%;
            }

            .chart {
                max-width: 1050px;
            }
        }
    }

    .sub-header {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left {
            display: flex;
            justify-content: space-between;
            align-items: center;

            i {
                font-size: 18px !important;
            }

            .title {
                font-size: 19px;
            }
        }

        .right {
            min-width: 80px;
            display: flex;
            gap: 10px;
            padding: 5px 10px;
            user-select: none;

            .export-button {
                border: 1px solid #008aff;
                padding: 5px;
                cursor: pointer;
                color: #008aff;
                border-radius: 4px;

                &:hover {
                    background: var(--color-bg-hover);
                }

                i {
                    color: #008aff;
                    font-size: 17px !important;
                }
            }
        }
    }

    .charts-wrapper {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-top: 20px;
    }

    .custom-card-report {
        min-height: 500px !important;
        background-color: #ffffff;
        padding: 15px 20px;
        border-radius: 6px;
        border: 1px solid #e8e8e8;
    }

    .charts-container {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .blocks.ant-table-wrapper {
        .blockName:hover {
            text-decoration: underline !important;
        }
    }
}
</style>
